import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Property } from '@app/_components/yield-max/property';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class PropertyService {

	statuses: any = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Canceled' }
	];

	statusType: any = [
		{ value: '1', name: 'Str' },
		{ value: '2', name: 'Composite' },
		{ value: '3', name: 'Hotel' }
	];

	propertyTypes = [
		{ value: '14', name: 'Single Family Home' },
		{ value: '01', name: 'Condominium' },
		{ value: '16', name: 'Townhome' }

	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'properties';

	add(property: Property): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(property));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, property);
	}

	update(property: Property): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, property);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	propertySummaryList(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/properties/summary-list`).pipe(retry({ count: 2, delay: 1500 }));
	}

	syncAllProperties(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/sync/properties`);
	}

	generateAllRates(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/rates/generate`);
	}

	surgicalRemoveAllLos(): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/surgical-removal`);
	}

	generateRateByProperty(propertyId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/rates/generate/`+propertyId);
	}

	generateRateLosByProperty(propertyId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/generate/`+propertyId);
	}

	yieldMaxSurgicalDeleteRateLos(propertyId: any): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/surgical-removal/`+propertyId);
	}

	yieldMaxDeleteAndRegenerateAllLos(propertyId: any): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.yieldMaxApiUrl}/ratesLos/remove-regenerate-all/`+propertyId);
	}

	wikiSurgicalDeleteRateLos(extSystemId: any): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/rate-detail-los/surgical-removal/`+extSystemId);
	}

	syncReservationsByProperty(propertyId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/sync/reservations/`+propertyId);
	}

	syncPropertyById(propertyId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/sync/properties/`+propertyId);
	}

	getSqsStatus(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/sqs/status`);
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findPropertyByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/properties`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(propertyId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${propertyId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
